/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import Slider from "react-slick";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import Cta from "@qlik/qlik/src/components/Cta";
import { getResponsiveImageUrl } from "@qlik/qlik/src/lib/utils";
import * as styles from "./styles.module.css";

const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    variableWidth: true,
    adaptiveHeight: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                variableWidth: false,
                dots: true,
                arrows: false,
            },
        },
    ],
};

const ClientSlider = ({ data }) => {
    const { title, description, additionalConfiguration, backgroundColor, cardItems = [], customId } = data ?? {};
    // Get the class name for the section padding
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration);
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section
            className={`overflow-hidden py-15 lg:py-30 ${sectionPaddingClassName} ${sectionColorMapping.bgColor}`}
            id={customId}
        >
            <div className="container">
                {title && (
                    <div className="row">
                        <div className="col-12 md:col-6">
                            {title && <h2 className="mb-9 lg:mb-15 lg:pl-3.75">{title}</h2>}
                            {description?.description && (
                                <p
                                    className={`body-big text-center lg:pl-3.75 mb-5 ${sectionColorMapping.secondaryTextColor}`}
                                >
                                    {description?.description}
                                </p>
                            )}
                        </div>
                    </div>
                )}
                <div className="row">
                    <div
                        className={`col-12 ${styles.slider} m-0 p-1.25 lg:p-0 lg:-mx-0.5 ${sectionColorMapping.bgColor} relative slick-arrow-top-right before:block before:z-1 before:absolute before:top-0 before:w-screen before:h-full before:right-full before:bg-inherit after:block after:z-1 after:absolute after:top-0 after:w-screen after:h-full after:left-full after:bg-inherit`}
                    >
                        <Slider {...settings}>
                            {cardItems?.map((card) => {
                                const cardImage = getResponsiveImageUrl(
                                    card?.media,
                                    typeof window !== "undefined" ? window.innerWidth : 0
                                );
                                return (
                                    <div className="px-2.5 lg:px-6.25 h-full" key={card.id}>
                                        <div className="slider-card flex flex-col bg-white h-full lg:flex lg:flex-row-reverse">
                                            {cardImage && (
                                                <div className="w-100 image-container">
                                                    <Media
                                                        link={cardImage}
                                                        className=" w-100 h-full object-cover leading-snug  tracking-tight4"
                                                    />
                                                </div>
                                            )}
                                            <div className="p-7.5 lg:p-10 content-container flex flex-col justify-between ">
                                                {card?.icon?.[0]?.secure_url && (
                                                    <div>
                                                        <Media
                                                            link={card?.icon?.[0]?.secure_url}
                                                            className="w-full h-[15px] mb-5 lg:h-10 lg:py-2.25 object-contain object-left lg:mb-7.5 "
                                                        />
                                                        <p className="body-text">{card?.description?.description}</p>
                                                    </div>
                                                )}
                                                <div>
                                                    {card.title && (
                                                        <h3 className=" text-md font-bold mb-1.25 leading-snug tracking-tight4 text-ocean">
                                                            {card.title}
                                                        </h3>
                                                    )}
                                                    {card.subtitle && (
                                                        <p className=" text-sm font-normal ">{card.subtitle}</p>
                                                    )}
                                                </div>
                                            </div>
                                            {card?.cta && card?.cta?.length > 0 && (
                                                <div className="mt-7.5 flex-col lg:flex-row ">
                                                    <div className="flex ">
                                                        {card?.cta?.map((ct) => (
                                                            <Cta key={ct.id} card={ct} className="block mb-7.5" />
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ClientSlider;
